import {
  actUponRadarFatalError,
  getMutationParameters as getRadarMutationParameters,
} from './actUponRadarFatalError';

import type { MutationParameters } from './types';
import type { RadarCreateSessionsQueryType } from '@web-platform/shared-universal-types/src/network/requestTypes';
import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { State } from '@web-platform/shared-universal-types/src/redux/banana/state/state-banana-types';
import type { Dispatch, Store } from 'redux';

const actUponFatalError = (
  getIsFatalError: () => MutationParameters<RadarCreateSessionsQueryType>,
  dispatch: Dispatch<Action>,
  store: Store<State, Action>,
): void => actUponRadarFatalError(getIsFatalError, store);

const getMutationParameters = (state: State): MutationParameters<RadarCreateSessionsQueryType> =>
  getRadarMutationParameters(state);

export { actUponFatalError, getMutationParameters };
